export default "__VITE_ASSET__fe10756d__"